import { countryNames } from '@airwallex/country-and-currency-names';

// Mirrors billing-pdf-generator's `src/util/country.ts` (source of truth) but
// uses the locally available @airwallex lib. Falls back to English when the
// active language has no localized country name.
export const getCountryName = (code?: string | null, lang = 'en'): string => {
  if (!code) return '';
  const entry = (countryNames as Record<string, Record<string, string> | undefined>)[code.toUpperCase()];
  if (!entry) return code;
  return entry[lang] || entry.en || code;
};
